
var React = require('react');

module.exports = function() {
  return React.createElement(
	"svg",
	{ viewBox: "0 0 64 64" },
	React.createElement("path", { d: "m61.1 18.2c-6.4-17-27.2-9.4-29.1-.9-2.6-9-22.9-15.7-29.1.9-6.9 18.5 26.7 35.1 29.1 37.8 2.4-2.2 36-19.6 29.1-37.8", fill: "#ff5a79" })
);
};



//////////////////
// WEBPACK FOOTER
// ./~/react-svg-emojione/dist/heart.js
// module id = 701
// module chunks = 0